import { render, staticRenderFns } from "./share-popover.vue?vue&type=template&id=ebd5e872&scoped=true&"
import script from "./share-popover.vue?vue&type=script&lang=js&"
export * from "./share-popover.vue?vue&type=script&lang=js&"
import style0 from "./share-popover.vue?vue&type=style&index=0&id=ebd5e872&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd5e872",
  null
  
)

export default component.exports